export const SET_EDIT_TABLE = 'set_edit_table';
